import classNames from "classnames";
import { isNil } from "lodash";

import type { CellSchema } from "app/pages/benchmark-tracker/components/Report/MetricElements/TableView/type";

export const ChangeRankCell = ({ value }: CellSchema) => {
    if (typeof value === "string") {
        value = +value;
    }

    const iconClasses = classNames("changePercentage-icon", {
        "sw-icon-arrow-up5": value > 0,
        "sw-icon-arrow-down5": value < 0,
    });

    const classes = classNames("changePercentage", {
        negative: value < 0,
        positive: value > 0,
    });

    const absValue = isNil(value) ? "-" : Math.abs(value);

    return (
        <div className={classes}>
            <i className={iconClasses} /> {absValue}
        </div>
    );
};
